import init from "@/javascripts/shared/utils/init"
import { delegateEventListener } from "@oddcamp/js-utils/src/event"

init(() => {
  const applyAccessibilityMode = (enabled) => {
    if (enabled) {
      document.body.classList.add(`accessibility-mode`)
      document.documentElement.classList.add(`accessibility-mode`)
    } else {
      document.body.classList.remove(`accessibility-mode`)
      document.documentElement.classList.remove(`accessibility-mode`)
    }

    document.querySelectorAll(`.js--accessibility-toggler`).forEach((el) => {
      const enabledIcon = el.querySelector(`.-enabled`)
      const disabledIcon = el.querySelector(`.-disabled`)

      if (enabledIcon && disabledIcon) {
        if (enabled) {
          enabledIcon.classList.remove(`is-hidden`)
          disabledIcon.classList.add(`is-hidden`)
        } else {
          enabledIcon.classList.add(`is-hidden`)
          disabledIcon.classList.remove(`is-hidden`)
        }
      }
    })
  }

  delegateEventListener(`.js--accessibility-toggler`, `click`, (e, el) => {
    const isEnabled = !document.body.classList.contains(`accessibility-mode`)
    applyAccessibilityMode(isEnabled)

    if (isEnabled) {
      const date = new Date()
      date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000)
      document.cookie = `accessibility_mode=true; expires=${date.toUTCString()}; path=/; SameSite=Lax`
    } else {
      document.cookie = `accessibility_mode=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`
    }

    const hamburgerEl = document.querySelector(`#vb-web-nav-hamburger-btn`)

    // If from mobile menu
    if (hamburgerEl) {
      if (hamburgerEl.classList.contains(`-active`)) {
        hamburgerEl.click()
      }
    }

    e.preventDefault()
  })
})
